import { render, staticRenderFns } from "./FooterRowSponsors.vue?vue&type=template&id=34d662d5&scoped=true"
import script from "./FooterRowSponsors.vue?vue&type=script&lang=js"
export * from "./FooterRowSponsors.vue?vue&type=script&lang=js"
import style0 from "./FooterRowSponsors.vue?vue&type=style&index=0&id=34d662d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d662d5",
  null
  
)

export default component.exports